import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TBlock, TStylesIndex } from './models';

export const Block: FC<TBlock> = props => {
    const {
        border,
        borderColor,
        children,
        className,
        dataTestId,
        fullHeight,
        id,
        innerRef,
        overflowHidden,
        styles,
        theme = 'transparent',
        ...rest
    } = props;

    const borderStyles: Partial<Record<TStylesIndex, string | number>> = {};

    /*
     * TODO: Бордер пока в camelCase не перевести быстро, так как в пропс передаются значения такого типа dark-indigo-20
     * Плюс нужно учесть обратную совместимость в ASSR
     */
    if (typeof borderColor !== 'undefined') {
        borderStyles[styles[`border-${borderColor}`] as TStylesIndex] = borderColor;
    }

    const classNames = cn(
        styles.block,
        styles[theme],
        {
            [styles.border]: border && !borderColor,
            ...borderStyles,
            [styles.fullHeight]: fullHeight,
            [styles.overflowHidden]: overflowHidden,
        },
        className
    );

    return (
        <div ref={innerRef} className={classNames} data-test-id={dataTestId} id={id} {...rest}>
            {children}
        </div>
    );
};
